import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`

    * {
        color: ${({ theme }) => theme.color.black};
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    
    html, body , header, nav, aside, main, section, article, footer, div {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
    }

    h1, h2, h3, h4, h5, h6, p, span {
        width: fit-content;
        min-height: 0;
        font-size: 16px;
        font-weight: 400;
        white-space: pre-wrap;
        word-break: break-all;
    }

    table {
        border-collapse: collapse;
    }

    a {
        width: fit-content;
        text-decoration: none;
        cursor: pointer;
    }

    textarea, input {
        border: none;
        outline: none;
        resize: none;
    }

    button {
        cursor: pointer;
        background-color: #00000000;
        border: none;
        outline: none;
        white-space: nowrap;
    }

    select {
        border: none;
        outline: none;
        -o-appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
`

export default GlobalStyle